import React from 'react';
import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';
import imgSVG from './assets/classic-report-app-skeleton.tpl.svg';

export const ClassicReportSkeleton = () => <AppSkeletonImage src={imgSVG} />;
